import { Stack } from '@nautilusbio/nb-design-system/Stack';
import { Text } from '@nautilusbio/nb-design-system/Text';
import clsx from 'clsx';
import React, { FC, ReactNode } from 'react';

import styles from './styles.module.css';

const Empty: FC<{ body: ReactNode; className?: string; title: ReactNode }> = ({ body, className, title }) => {
  return (
    <Stack
      alignItems="center"
      className={clsx(styles.emptyColors, className ? className : styles.empty)}
      gap={4}
      justifyContent="center"
    >
      <Text as="h2" aria-live="polite">
        {title}
      </Text>

      <Text as="div">{body}</Text>
    </Stack>
  );
};

export default Empty;
